import client from '@/api/client'

export interface AllegatoIntake {
  nome_file: string
  content_type: string
  dimensione: number
  url: string
}

export interface IntakePending {
  id: string
  canale: string
  mittente: string
  oggetto: string | null
  corpo_testo: string
  classificazione_ai: any
  confidenza: number | null
  azione_suggerita: string | null
  stato: string
  ticket_id: string | null
  rifiutata_motivo: string | null
  allegati: AllegatoIntake[]
  created_at: string | null
}

export async function fetchPending(limit = 100, offset = 0): Promise<IntakePending[]> {
  const res = await client.get('/intake-coda/pending', { params: { limit, offset } })
  return res.data
}

export async function countPending(): Promise<number> {
  const res = await client.get('/intake-coda/count-pending')
  return res.data.count
}

export async function approvaPending(id: string, body?: Record<string, any>): Promise<void> {
  await client.patch(`/intake-coda/${id}/approva`, body || {})
}

export async function rifiutaPending(id: string, motivo: string): Promise<void> {
  await client.patch(`/intake-coda/${id}/rifiuta`, { motivo })
}

export async function modificaPending(id: string, body: Record<string, any>): Promise<void> {
  await client.patch(`/intake-coda/${id}/modifica`, body)
}

export async function eliminaPending(id: string): Promise<void> {
  await client.delete(`/intake-coda/${id}`)
}

export const intakeCodaKeys = {
  all: ['intake-coda'] as const,
  pending: () => [...intakeCodaKeys.all, 'pending'] as const,
  count: () => [...intakeCodaKeys.all, 'count-pending'] as const,
}
